import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import pathnames from './pathnames';

const RouteWithRedirect = (props: RouteProps & { enabled?: boolean }) => (
  <Route
    {...props}
    {...((props.enabled ?? true)
      ? {}
      : { render: () => <Redirect to={pathnames.notFound()} /> })}
  />
);

export default RouteWithRedirect;
